import { UserProfileModel } from './user-profile.model';

export enum DefaultSupervisionScopeEnum {
  TENANT = 'tenant',
  ESTABLISHMENT = 'establishment',
}

export enum DefaultSupervisionMetrikTypeEnum {
  BUILDING = 'building',
  EQUIPMENT = 'equipment',
}

export enum DefaultSupervisionNodeTypeEnum {
  GENERIC_BUILDING_CATEGORY = 'genericBuildingCategory',
  GENERIC_BUILDING = 'genericBuilding',
  EQUIPMENT_TYPE = 'equipmentType',
  GENERIC_EQUIPMENT = 'genericEquipment',
}

export enum DefaultSupervisionPropagationModeEnum {
  ALL = 'all',
  ONLY_DEFAULT = 'onlyDefault',
  NONE = 'none',
}

export type DefaultSupervisionInheritedFrom = 'parent' | 'tenant' | 'tenantParent';

export interface DefaultSupervisionContact {
  _id: string;
  firstName: string;
  lastName: string;
}

export interface DefaultSupervisionTreeNode {
  _id: string | null;
  label: string;
  nodeType?: DefaultSupervisionNodeTypeEnum;
  metrikType: DefaultSupervisionMetrikTypeEnum;
  assignable: boolean;
  ownContact?: DefaultSupervisionContact;
  inheritedContact?: DefaultSupervisionContact;
  inheritedFrom?: DefaultSupervisionInheritedFrom;
  children?: DefaultSupervisionTreeNode[];
}

export interface DefaultSupervisionAssignPayload {
  scope: DefaultSupervisionScopeEnum;
  establishment?: { _id: string; label: string; technicalIdentifier?: string };
  metrikType: DefaultSupervisionMetrikTypeEnum;
  nodeType: DefaultSupervisionNodeTypeEnum;
  node: { _id: string; label: string };
  contactIntern: DefaultSupervisionContact;
  propagationMode: DefaultSupervisionPropagationModeEnum;
}

export interface DefaultSupervisionUnassignPayload {
  scope: DefaultSupervisionScopeEnum;
  establishmentId?: string;
  nodeType: DefaultSupervisionNodeTypeEnum;
  nodeId: string;
  propagationMode: DefaultSupervisionPropagationModeEnum;
}

export interface DefaultSupervisionReplaceContactPayload {
  oldContactId: string;
  newContact?: DefaultSupervisionContact;
  establishmentId?: string;
  /**
   * ALL = efface aussi le superviseur saisi manuellement sur les Metrik (retour au défaut
   * dynamique) ; ONLY_DEFAULT = ne touche que les affectations par défaut.
   */
  propagationMode?: DefaultSupervisionPropagationModeEnum;
}

export interface DefaultSupervisionDependencies {
  data: { name: string; dependencies: string[] }[];
  hasDependencies: boolean;
  canChangeDependencies: boolean;
  canArchiveWithDependencies: boolean;
}

export type DefaultSupervisionAssignableContact = UserProfileModel & { fullName?: string };

export type DefaultSupervisionSource = 'establishment' | 'tenant';

/** Restitution du superviseur par défaut résolu d'une Metrik, une ligne par établissement. */
export interface DefaultSupervisionResolvedLine {
  establishment?: { _id: string; label: string };
  contact?: DefaultSupervisionContact;
  source?: DefaultSupervisionSource;
}
